function Banner() {
  return (
    <div class="relative container mx-auto grid gap-0  lg:gap-5  lg:grid-cols-4">
      <div class="lg:col-span-3  mb-2 relative">
        <div class="absolute lg:my-24 right-0 text-center lg:text-right mx-24 ">
          <h3 class="uppercase text-sm lg:text-xl text-white">lastest American</h3>
          <h2 class="uppercase text-sm lg:text-white text-5xl font-bold">Leather sofa</h2>
          <h4 class="uppercase text-sm lg:text-white text-xl">Pure Edition</h4>
          <button class="mt-4 uppercase text-sm rounded p-2 lg:p-4 text-white bg-black hover:bg-blue-800">
            View Collection
          </button>
        </div>
        <img
          alt=""
          src="imgs/sofa.jpg"
          class="object-contain h-64 lg:object-cover object-center w-full lg:h-full "
        />
      </div>
      <div class="shadow-xl">
        <img
          alt=""
          src="imgs/arm-chair.jpg"
          class="lg:object-contain object-cover object-center w-full lg:h-48 mb-2"
        />
        <img
          alt=""
          src="imgs/hoddie.jpg"
          class="object-cover object-center w-full lg:h-64 mb-2"
        />
      </div>
      <div class=" shadow-xl">
        <img
          alt=""
          src="imgs/sofa-brown.jpg"
          class="lg:object-contain object-center w-full h-24 mb-2"
        />
      </div>
      <div class=" ">
        <img
          alt=""
          src="imgs/bn2.jpg"
          class="object-cover object-center w-full h-24 mb-2"
        />
      </div>
      <div class=" ">
        <img
          alt=""
          src="imgs/bn3.jpg"
          class="object-cover object-center w-full h-24 mb-5"
        />
      </div>
    </div>
  );
}

export default Banner;
